/* unplugin-vue-components disabled */import { render } from "./CreateAuthorization.vue?vue&type=template&id=dd997282"
import script from "./CreateAuthorization.vue?vue&type=script&lang=js"
export * from "./CreateAuthorization.vue?vue&type=script&lang=js"

import "./CreateAuthorization.vue?vue&type=style&index=0&id=dd997282&lang=scss"

import exportComponent from "D:\\Project\\Juanfu\\CBK定制版\\hcontrol_download\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__